module.exports = {
      id: "back-icon-usage",
      viewBox: "0 0 7.828 12.828",
      url: "/" + "sprite-79b777a110ad18271a4fc79289e4208e.svg#back-icon",
      toString: function () {
        return this.url;
      }
    }